import { Tile } from '@timeflies/tilemap-utils';
export var tileInfosGetter = function (_a) {
    var mapSheet = _a.mapSheet, layer = _a.layer;
    return function (id, index) {
        var tileset = Tile.getTilesetFromTileId(id, mapSheet);
        if (!tileset) {
            return null;
        }
        var tilePos = Tile.getTilePositionFromIndex(index, mapSheet);
        var worldPos = Tile.getWorldPositionFromTilePosition(tilePos, tileset, layer);
        return { tileset: tileset, tilePos: tilePos, worldPos: worldPos };
    };
};
